// Single source of truth for the portfolio owner's name.
// Import this constant wherever a fallback name is needed.
export const OWNER_NAME = "Jay Kisan Das";

// Brand name displayed in the navbar and admin topbar.
export const BRAND_NAME = "JAY.DEV";

// This is fallback/template data used when Firestore is unavailable.
// Populate your real personal details (location, DOB, contacts, address)
// via the Admin panel so they live only in Firestore and not in source code.

export const defaultPortfolioData = {
  profile: {
    name: "Jay Kisan Das",
    headline: "Technical Lead @HashedIn by Deloitte | 8+ Years in Angular | Architecting High-Impact, User-Centric Web & Mobile Apps | Passionate About Driving Innovation and Streamlining Solutions",
    roles: ["Generative AI Enthusiast", "Full Stack Engineer", "React Developer", "Angular Developer", "Mobile App Developer", "UI / UX Enthusiast"],
    summary:
      "With over eight years of experience in software development, I specialize in building scalable web and mobile applications using Angular and Ionic frameworks. Currently working as an SDE 3 in the UI Capability team at HashedIn by Deloitte, I focus on delivering high-performance, user-centric solutions that align with business goals and enhance user experience.\n\nOver the years, I have led complex projects, collaborated with cross-functional teams, and contributed to building reusable UI architectures and efficient development practices. I am also adept at leveraging AI tools and modern technologies to improve productivity, accelerate development, and adapt quickly to evolving industry trends.\n\nPassionate about innovation and continuous learning, I enjoy mentoring developers, optimizing application performance, and building collaborative engineering cultures. I am always open to connecting with professionals who share an interest in technology, AI-driven development, and digital transformation.",
    location: { from: "Jajpur, Odisha", livesIn: "Bengaluru, Karnataka" },
    photoUrl: "https://media.licdn.com/dms/image/v2/D5603AQG1Y2lQTJnlvg/profile-displayphoto-crop_800_800/B56ZlcNNxjH8AI-/0/1758188594007?e=1781136000&v=beta&t=keYWkpSHHcc-IGtNiXqOoTHnubWJrIcJ9mKKTVHzAPQ",
    noticePeriod: "60 days",
    openToRelocation: "Open to discussion",
    workAuthorization: "Indian Citizen - No Visa Required",
  },
  skills: {
    categories: [
      {
        category: "Languages",
        items: ["JavaScript", "TypeScript", "HTML5", "CSS3", "SCSS / SASS", "Java", "Python", "SQL"],
      },
      {
        category: "Frameworks & Libraries",
        items: ["Angular (v9 - v21)", "React.js", "Ionic 6", "Capacitor 4", "Bootstrap", "RxJS", "NgRx", "Node.js"],
      },
      {
        category: "AI & Emerging Tech",
        items: ["Generative AI", "Prompt Engineering", "LLM Integration"],
      },
      {
        category: "Cloud & DevOps",
        items: ["AWS", "Firebase", "Microsoft Azure", "Azure DevOps", "CI/CD", "Docker", "GitHub Actions", "Git"],
      },
      {
        category: "APIs & Data",
        items: ["REST APIs", "GraphQL", "MySQL"],
      },
      {
        category: "Tools & Platforms",
        items: ["Adobe Experience Manager (AEM)", "Android Studio", "JIRA", "Figma", "Postman"],
      },
      {
        category: "Security & Architecture",
        items: ["Web Application Security", "Cross-platform Development", "Search Engine Optimization (SEO)"],
      },
      {
        category: "Process & Methodology",
        items: ["Agile / Scrum", "Unit Testing", "Team Coordination", "DevOps"],
      },
      {
        category: "Interpersonal",
        items: ["Technical Leadership", "Mentoring", "Motivational Speaking", "Stakeholder Management"],
      },
    ],
  },
  education: [
    {
      year: "2014 - 2018",
      name: "National Institute of Science and Technology",
      university: "Biju Patnaik University of Technology (B.P.U.T.)",
      degree: "B.Tech., Computer Science",
    },
    {
      year: "2012 - 2014",
      name: "Kendriya Vidyalaya",
      university: "Central Board of Secondary Education (C.B.S.E.)",
      degree: "+2, Computer Science",
    },
    {
      year: "2003 - 2012",
      name: "Kendriya Vidyalaya",
      university: "Central Board of Secondary Education (C.B.S.E.)",
      degree: "Primary",
    },
  ],
  experience: [
    {
      year: "Sep 2024 - Present",
      name: "Hashedin by Deloitte",
      designation: ["Assistant Manager"],
      location: "Bengaluru, India · Hybrid",
      employmentType: "Full-time",
      techStack: ["Angular 19", "TypeScript", "Azure Boards", "GenAI", "Security Engineering"],
      desc: [
        "Led a 7-member team in building a secure web application for Deloitte Tax, focusing on high-level data protection and breach prevention.",
        "Team Leadership: Directed 7 developers through the full SDLC, ensuring all security and performance milestones were met.",
        "Agile Management: Orchestrated the full project lifecycle using Azure Boards, managing sprints, backlogs, and work items for a 7-member team.",
        "Security Engineering: Developed robust frameworks to defend against external threats, including XSS, SQL injection, and unauthorized access.",
        "Vulnerability Management: Conducted proactive penetration testing and code reviews to eliminate security gaps prior to launch.",
        "AI Optimization: Leveraged GenAI to accelerate code reviews, automate documentation, and optimize complex logic, increasing team productivity.",
        "Stakeholder Management: Served as the technical lead coordinating between developers and senior stakeholders to align security goals.",
      ],
    },
    {
      year: "Jul 2024 - Sep 2024",
      name: "Amadeus Labs",
      designation: ["Senior Software Developer"],
      location: "Bengaluru, India · Hybrid",
      employmentType: "Contract",
      techStack: ["Angular 18", "TypeScript"],
      desc: [],
    },
    {
      year: "Feb 2022 - Sep 2024",
      name: "PwC India",
      designation: [
        "Assistant Manager (Apr 2023 - Sep 2024)",
        "Associate (Feb 2022 - Mar 2023)",
      ],
      location: "Bengaluru, India · Remote",
      employmentType: "Full-time",
      techStack: ["Angular", "Ionic", "TypeScript", "Firebase", "JavaScript"],
      desc: [
        "Led Technology Strategy Development: Spearheaded the formulation of technology strategies for clients, aligning their business goals with innovative technological solutions.",
        "Client Advisory and Relationship Management: Advised key clients on technology initiatives, providing expert insights on adopting emerging technologies, optimizing IT infrastructure, and enhancing cybersecurity measures.",
        "Project Management and Team Leadership: Managed end-to-end project lifecycles, overseeing the execution of complex technology projects, directing multidisciplinary teams, and ensuring timely delivery within budget.",
        "Spearheaded the design and development of innovative software solutions using Angular and Ionic, leading a team of developers to deliver high-quality applications.",
        "Collaborated with clients to understand their technological requirements and provided strategic recommendations, aligning technology initiatives with overall business strategies.",
        "Guided and mentored junior developers, fostering a culture of continuous learning and growth within the team.",
      ],
    },
    {
      year: "May 2020 - Feb 2022",
      name: "tyfone, Inc.",
      designation: ["Software Engineer"],
      location: "Bengaluru, India · Remote",
      employmentType: "Full-time",
      techStack: ["Angular 9", "React", "JavaScript", "HTML", "CSS", "REST APIs"],
      desc: [
        "Engaged with clients to thoroughly comprehend their requirements and proposed effective solutions, fostering transparent communication within the team.",
        "Demonstrated proactive learning by staying abreast of the latest mobile app development practices; successfully adapted existing web applications for diverse browsers, mobile devices, and platforms.",
        "Showcased exceptional teamwork by collaborating with cross-functional colleagues to consistently innovate app functionality and design; mentored team members and oversaw their activities for punctual delivery.",
      ],
    },
    {
      year: "Mar 2019 - Apr 2020",
      name: "Livsoft Engineering Private Limited",
      designation: ["Associate Software Engineer"],
      location: "Bengaluru, India · On-site",
      employmentType: "Full-time",
      techStack: ["JavaScript", "CSS", "jQuery", "HTML", "Front-end Development"],
      desc: [
        "Spearheaded the development of dynamic client-side web applications, leveraging HTML to craft engaging and user-centric web pages and enhancing overall user experience.",
        "Collaborated with back-end developers and web designers to elevate usability and aesthetics; produced high-quality mockups and prototypes facilitating comprehensive visualization of application design.",
        "Showcased expertise in JavaScript, CSS, and jQuery; conducted comprehensive browser testing and debugging ensuring a seamless, error-free user experience with awareness of SEO principles.",
      ],
    },
    {
      year: "Jun 2018 - Feb 2019",
      name: "Goalsr Inc",
      designation: ["Associate Software Engineer"],
      location: "Bengaluru, India · On-site",
      employmentType: "Full-time",
      techStack: ["HTML", "CSS", "JavaScript"],
      desc: [
        "Executed the role of Front-End Web Developer by utilizing HTML, CSS, and JavaScript, melding the realms of design and programming; transformed UI/UX design wireframes into tangible code.",
        "Collaborated closely with the UI/UX designer, bridging the gap between graphical design and technical execution, defining both visual aesthetics and functional behaviour.",
        "Fashioned interactive prototypes using insights from the product team, unearthing possibilities for enhancement; reduced time-to-market completion by 25%, accelerating project delivery.",
      ],
    },
  ],
  projects: [
    {
      title: "Philippines Airlines",
      desc: "Airline industry product with Angular 18 and AEM",
      company: "Amadeus Labs",
      role: "Frontend Developer",
      year: "Jun 2024 - Sep 2024",
      techStack: ["Angular 18", "Adobe Experience Manager (AEM)", "TypeScript"],
      bullets: [
        "Developed a product for the airline industry using Angular 18 for the frontend and AEM.",
        "Built a custom library to integrate custom components into the AEM interface, enabling drag-and-drop widgets for constructing the entire application.",
        "Optimized application performance and ensured SEO compliance.",
      ],
      demoUrl: "",
      repoUrl: "",
    },
    {
      title: "HCG - ePharmacy Mobile & Web App",
      desc: "Patient portal and ePharmacy portal for HCG hospitals",
      company: "PwC India",
      role: "Lead Frontend Developer",
      year: "Jun 2023 - Apr 2024",
      techStack: ["Angular", "Ionic", "TypeScript", "GraphQL", "REST APIs"],
      bullets: [
        "Led a team of three in developing and maintaining mobile and web applications — a patient portal and an ePharmacy portal — using Angular and Ionic.",
        "Implemented complex business logic and integrated with REST APIs and GraphQL.",
        "Managed the full development lifecycle from requirements to production rollout.",
      ],
      demoUrl: "",
      repoUrl: "",
    },
    {
      title: "Reserve Bank of India - Mobile App Revamp & Redesign",
      desc: "Official RBI mobile app rebuild with Angular & Ionic",
      company: "PwC India",
      role: "Frontend Developer",
      year: "Jun 2022 - May 2023",
      techStack: ["Angular", "Ionic", "TypeScript", "Liferay REST APIs"],
      bullets: [
        "Developed and maintained mobile applications using Angular and Ionic, implementing complex business logic and integrating with Liferay REST APIs.",
        "Collaborated with cross-functional teams to ensure project completion within the given time frame.",
        "Wrote and maintained code documentation; participated in code reviews and testing to ensure high-quality code.",
        "Published on the Google Play Store with a 4.2★ average rating.",
      ],
      demoUrl: "https://play.google.com/store/apps/details?id=com.reservebankofindia.app",
      repoUrl: "",
    },
    {
      title: "nFinia",
      desc: "Digital banking platform for credit unions",
      company: "tyfone, Inc.",
      role: "Software Engineer",
      year: "May 2020 - Feb 2022",
      techStack: ["Angular", "Ionic", "TypeScript", "REST APIs"],
      bullets: [
        "Part of the delivery team for nFinia, a product built on Angular 14 with Ionic, configuring the product for multiple credit unions.",
        "Worked on enhancements, bug fixes, and new features including money transfers, bill payments, and check deposits.",
      ],
      demoUrl: "",
      repoUrl: "",
    },
    {
      title: "Yelligo",
      desc: "Field sales force tracking & management system",
      company: "Livsoft Engineering Private Limited",
      role: "Frontend Developer",
      year: "Dec 2019 - Mar 2020",
      techStack: ["JavaScript", "HTML", "CSS", "Google Maps API"],
      bullets: [
        "Built a field sales force tracking system web portal for admins to track all activities of the sales force in real-time.",
        "Features: real-time location tracking, visit management, productivity improvements, dynamic staff deployment, detailed report downloads, attendance management, expense reimbursement, and custom forms.",
      ],
      demoUrl: "https://play.google.com/store/search?q=yelligo&c=apps",
      repoUrl: "",
    },
    {
      title: "H-Sales India",
      desc: "In-house field sales demo app for Hyundai India",
      company: "Livsoft Engineering Private Limited",
      role: "Frontend Developer",
      year: "Oct 2019 - Dec 2019",
      techStack: ["JavaScript", "HTML", "CSS"],
      bullets: [
        "Built an in-house application for Hyundai India to manage field demos to customers, working in both online and offline modes.",
        "Admin portal for managing all data including promotional images, product catalogues, and descriptions.",
      ],
      demoUrl: "",
      repoUrl: "",
    },
    {
      title: "Hyundai CRM and E-Commerce",
      desc: "CRM and e-commerce platform for Hyundai India",
      company: "Livsoft Engineering Private Limited",
      role: "Frontend Developer",
      year: "May 2019 - Jul 2019",
      techStack: ["JavaScript", "HTML", "CSS"],
      bullets: [
        "Developed CRM and e-commerce features for Hyundai India's internal platform.",
      ],
      demoUrl: "",
      repoUrl: "",
    },
    {
      title: "CannERP",
      desc: "Complete ERP suite for cannabis farming & operations",
      company: "Goalsr Inc",
      role: "Frontend Developer",
      year: "May 2019 - Jul 2019",
      techStack: ["JavaScript", "HTML", "CSS", "Bootstrap"],
      bullets: [
        "Built the Enterprise Suite ERP that consolidates all business processes into a single system.",
        "Covered core components: Sales & Purchase management, Inventory management, Operations & Human resources, tracking seeds, phases, ingredients, products, orders, and more.",
      ],
      demoUrl: "",
      repoUrl: "",
    },
    {
      title: "Enterprise Application for RushPCB - Proboard",
      desc: "Order management enterprise application for PCB manufacturing",
      company: "Goalsr Inc",
      role: "Frontend Developer",
      year: "Mar 2019 - May 2019",
      techStack: ["JavaScript", "HTML", "CSS"],
      bullets: [
        "Built an enterprise order management application to help SMEs streamline business operations through advanced workflow automation and end-to-end order fulfilment.",
      ],
      demoUrl: "",
      repoUrl: "",
    },
    {
      title: "GoERP",
      desc: "ERP web application for SMEs",
      company: "Goalsr Inc",
      role: "Frontend Developer",
      year: "Jan 2019 - Mar 2019",
      techStack: ["JavaScript", "HTML", "CSS"],
      bullets: [
        "Built ERP software to help businesses overcome operational challenges and achieve greater sales and customer satisfaction.",
        "Web application for SMEs covering product planning, manufacturing, marketing, sales, inventory management, shipping, and payments.",
      ],
      demoUrl: "",
      repoUrl: "",
    },
    {
      title: "Website & Enterprise Application for Network PCB",
      desc: "Website and order management platform for PCB manufacturing",
      company: "Goalsr Inc",
      role: "Frontend Developer",
      year: "Jul 2019 - Sep 2019",
      techStack: ["HTML", "CSS", "JavaScript", "Bootstrap"],
      bullets: [
        "Designed a website to showcase Network PCB's expertise in printed circuit board manufacturing.",
        "Built an enterprise order management application to help SMEs streamline business operations through advanced workflow automation and end-to-end order fulfilment.",
      ],
      demoUrl: "https://networkpcb.com/",
      repoUrl: "",
    },
    {
      title: "Website for Goalsr India",
      desc: "Corporate website for Goalsr India",
      company: "Goalsr Inc",
      role: "Frontend Developer",
      year: "Sep 2019 - Oct 2019",
      techStack: ["HTML5", "CSS3", "Bootstrap 4", "JavaScript"],
      bullets: [
        "Designed a complete website for Goalsr India using HTML5, CSS3, Bootstrap 4, and JavaScript.",
        "Implemented responsive layouts and SEO best practices, improving search visibility.",
      ],
      demoUrl: "https://aboutus.goalsr.com/index.html",
      repoUrl: "",
    },
    {
      title: "eLearning - Virtual School Platform",
      desc: "Fully responsive online learning platform for Vietnamese students",
      company: "Goalsr Inc",
      role: "Frontend Developer",
      year: "Sep 2018 - Dec 2018",
      techStack: ["HTML", "CSS", "JavaScript", "Bootstrap"],
      bullets: [
        "Built a fully responsive virtual school web application for Vietnamese children, accessible on desktops, laptops, tablets, and mobiles.",
        "Admin features: upload MCQ/fill-in-the-blank/match-the-following questions, YouTube videos, documents; full student and admin management with dashboards.",
        "User features: self-registration, access to grade-specific materials, video watching, and practice tests.",
      ],
      demoUrl: "",
      repoUrl: "",
    },
    {
      title: "E-magazine Web Application",
      desc: "Full-fledged e-magazine platform with admin and user portals",
      company: "Goalsr Inc",
      role: "Frontend Developer",
      year: "Aug 2018 - Sep 2018",
      techStack: ["HTML", "CSS", "JavaScript"],
      bullets: [
        "Designed a full-fledged web application for an e-magazine with separate portals for users and admins.",
        "Both admins and users can upload news with images and documents; admin can review, approve, or disapprove user-uploaded content with notification messaging.",
        "Admin can manage advertisements on the platform.",
      ],
      demoUrl: "",
      repoUrl: "",
    },
    {
      title: "Website for CannERP",
      desc: "Marketing website for smart farming & cannabis ERP platform",
      company: "Goalsr Inc",
      role: "Frontend Developer",
      year: "Jun 2018 - Aug 2018",
      techStack: ["HTML", "CSS", "JavaScript"],
      bullets: [
        "Built the public-facing marketing website for CannERP, a smart farming and cannabis operations platform.",
        "Platform focused on precision farming, IT data solutions, real-time analysis, risk management, and supply chain management for agriculture.",
      ],
      demoUrl: "",
      repoUrl: "",
    },
    {
      title: "Multiple Classifier System for Texture Classification",
      desc: "Research project on novel classifier fusion strategy",
      company: "National Institute of Science and Technology",
      role: "Research Developer",
      year: "Jul 2017 - Mar 2018",
      techStack: ["Java", "Machine Learning"],
      bullets: [
        "Proposed a simple and effective novel classifier fusion strategy for multi-class texture classification.",
        "The training-based scheme fuses decisions of two base classifiers using their classification confidence to enhance final classification accuracy.",
        "MCS method showed better and consistent performance with the lowest standard deviation compared to fixed rule and simple trainable fusion techniques across all databases.",
      ],
      demoUrl: "",
      repoUrl: "",
    },
  ],
  certifications: [
    {
      name: "Meta Front-End Developer",
      issuer: "Meta (via Coursera)",
      date: "Nov 2024",
      credentialId: "71I3LDMYEE1J",
      credentialUrl: "https://www.coursera.org/account/accomplishments/professional-cert/certificate/71I3LDMYEE1J",
      skills: [],
    },
    {
      name: "Ionic & Angular",
      issuer: "Udemy",
      date: "Mar 2023",
      credentialId: "UC-ef0a6188-981e-41dd-9faa-f352de9e4201",
      credentialUrl: "",
      skills: ["Ionic 6", "Angular 13"],
    },
    {
      name: "Apache Cordova - Build Hybrid Mobile App for Android & iOS",
      issuer: "Udemy",
      date: "Jul 2022",
      credentialId: "UC-e228f0eb-5069-4262-8d84-7a62145bf799",
      credentialUrl: "",
      skills: ["Apache Cordova", "Hybrid Application"],
    },
    {
      name: "Responsive Web Design",
      issuer: "Sololearn",
      date: "Feb 2022",
      credentialId: "1162-4235229",
      credentialUrl: "https://www.sololearn.com/Certificate/1162-4235229/jpg",
      skills: ["Front-end Development"],
    },
    {
      name: "Angular + NestJS",
      issuer: "Sololearn",
      date: "Feb 2022",
      credentialId: "1092-4235229",
      credentialUrl: "https://www.sololearn.com/Certificate/1092-4235229/jpg",
      skills: ["Front-end Development", "Angular 9"],
    },
    {
      name: "Java",
      issuer: "Sololearn",
      date: "Mar 2021",
      credentialId: "4235229-1068",
      credentialUrl: "https://www.sololearn.com/certificates/course/en/4235229/1068/landscape/png",
      skills: [],
    },
    {
      name: "SQL",
      issuer: "Sololearn",
      date: "Dec 2019",
      credentialId: "4235229-1060",
      credentialUrl: "https://www.sololearn.com/certificates/course/en/4235229/1060/landscape/png",
      skills: [],
    },
    {
      name: "JavaScript",
      issuer: "Sololearn",
      date: "Sep 2018",
      credentialId: "4235229-1024",
      credentialUrl: "https://www.sololearn.com/certificates/course/en/4235229/1024/landscape/png",
      skills: ["Front-end Development"],
    },
    {
      name: "jQuery",
      issuer: "Sololearn",
      date: "Sep 2018",
      credentialId: "1082-4235229",
      credentialUrl: "https://www.sololearn.com/Certificate/1082-4235229/jpg",
      skills: ["Front-end Development"],
    },
    {
      name: "CSS",
      issuer: "Sololearn",
      date: "Aug 2018",
      credentialId: "1023-4235229",
      credentialUrl: "https://www.sololearn.com/Certificate/1023-4235229/jpg",
      skills: ["Front-end Development"],
    },
    {
      name: "HTML",
      issuer: "Sololearn",
      date: "Mar 2017",
      credentialId: "1014-4235229",
      credentialUrl: "https://www.sololearn.com/Certificate/1014-4235229/jpg",
      skills: ["Front-end Development"],
    },
    {
      name: "Network Management",
      issuer: "Indian Institute of Technology, Kharagpur",
      date: "May 2016",
      credentialId: "",
      credentialUrl: "",
      skills: [],
    },
    {
      name: "Oracle Database 11g: SQL",
      issuer: "National Institute of Science and Technology",
      date: "Jun 2015",
      credentialId: "NIST/ORA-2015/005",
      credentialUrl: "",
      skills: [],
    },
    {
      name: "C++",
      issuer: "LAKSHYA Solutions Limited",
      date: "Jun 2013",
      credentialId: "S-02-13-002253",
      credentialUrl: "",
      skills: [],
    },
  ],
  awards: [
    {
      title: "Spot Award",
      issuer: "Hashedin by Deloitte",
      year: "2024",
      url: "https://www.linkedin.com/feed/update/urn:li:activity:7415455966110101504/",
    },
    {
      title: "Above and Beyond Award",
      issuer: "PwC India",
      year: "2023",
      url: "https://www.linkedin.com/feed/update/urn:li:activity:7010098254671482880/",
    },
    {
      title: "Achievement Certificate",
      issuer: "Goalsr Inc",
      year: "2019",
      description: "For setting new standards in UI/UX with products",
      url: "",
    },
  ],
  languages: [
    { language: "Odia", proficiency: "Native or Bilingual" },
    { language: "Hindi", proficiency: "Full Professional" },
    { language: "English", proficiency: "Professional Working" },
  ],
  testimonials: [
    {
      name: "Chandramukhi Prakash",
      role: "HR / Recruitment / Leadership Hiring",
      img: "https://media.licdn.com/dms/image/v2/C4D03AQFpN9H1bpphFg/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1656061552860?e=1781136000&v=beta&t=kq6InEDNfed3r2QNxCD5zMtYQ96OD4JJNrakGiNiFfk",
      content:
        "Jay Kisan is a thorough professional. He is very talented. Quick Learner. Many a times has gone overboard to complete the projects in time. He is good asset to the company.",
    },
    {
      name: "Prem Anand",
      role: "Assistant General Manager, Denso",
      img: "https://media.licdn.com/dms/image/v2/C5103AQF4xBukFChVag/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1574824342868?e=1781136000&v=beta&t=AxTEEtZf6205XICMaAs575EJWxzEjfT54sjly4SI57I",
      content:
        "Working with Jay has two parts to it:\n1. He brings in lot of energy\n2. He will be the go to guy for your next POC.",
    },
    {
      name: "Durga Bastia",
      role: "Application Development Senior Analyst, Accenture",
      img: "https://media.licdn.com/dms/image/v2/D5603AQHQaA2JmuAVGA/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1725530707434?e=1781136000&v=beta&t=sxw-tYsXtI2JuuNDfbrpiEny7dqVqCqs4_qgGrOs8X4",
      content:
        "It's rare that you come across an outstanding talent like Jay Kisan. He is the most profound person I have met, and his ability to tackle any problem is remarkable and with a warm smile. I had a pleasant experience of working with Jay for about an year and I have also learnt many things from him, so the people who have already worked with him can agree with me, that the way of easily adjustable to a given situation made him really exceptional. His work ethics are highly recommendable and most important is his ability to go out of the way to help the others has made him stand out.",
    },
    {
      name: "Subham Singh",
      role: "Senior Software Engineer, Siemens",
      img: "https://media.licdn.com/dms/image/v2/D4E03AQGF8CjQL3xL4A/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1714021780248?e=1781136000&v=beta&t=Lc_JuemTxIlxw0d9X_C6wtClK68enoyhwiOtezQs1G0",
      content:
        "While working with you for almost 2 years, I found a guy who is brilliant, dynamic and responsible for his work. A great teammate with positive attitude towards colleagues and helping in nature. Technically strong with UI background and always open to learn new skills.",
    },
    {
      name: "Rahul Panda",
      role: "Data Engineer, Google",
      img: "https://media.licdn.com/dms/image/v2/D5603AQF409jFzPizlw/profile-displayphoto-scale_100_100/B56Z2CdbVoKcAc-/0/1776010246929?e=1781136000&v=beta&t=_akuv6QFv7lRApLA6VCyimVdCR4O58EAFHKEb_Yr9uQ",
      content:
        "Jay has been a very fervent web technology enthusiast since his days at college. His curiosity to learn new technologies, and to utilize the same for a prolific output made him stand ahead as a motivation for friends. Along with his involvement in web development activities for various college tournaments & events, he has also worked as a Student Guide, motivating and asserting positive educational & career growth of Juniors and team-mates.",
    },
    {
      name: "Paurush Srivastava",
      role: "Software Engineer III, Walmart",
      img: "https://media.licdn.com/dms/image/v2/D4D03AQF-egp8iPY2vg/profile-displayphoto-scale_100_100/B4DZnoWIRrGwAc-/0/1760539740391?e=1781136000&v=beta&t=HCO3wz8XcjtloJ6xYWSf9HI86ogynOn1tiJwdeDu1Fc",
      content:
        "Jay is well-known for his 'meeting the deadlines' attitude. He's a goal-oriented guy with long-term plans and has exceptional expertise in leadership & motivation. He's not only reliable and responsible but also an inspiring team player to work with.",
    },
  ],
  blog: [
    {
      url: "https://www.linkedin.com/posts/jay-kisan-das_eubrics-new-am-program-activity-7100717120325390336-9Ef4",
      tag: "Certification",
      title: "New AM Program by Eubrics",
      publishedDate: "Aug 25, 2023",
    },
    {
      url: "https://www.linkedin.com/posts/jay-kisan-das_generative-ai-for-business-leaders-activity-7070293674185691136-ZiVE",
      tag: "Certification",
      title: "Generative AI for Business Leaders",
      publishedDate: "Jun 03, 2023",
    },
    {
      url: "https://www.linkedin.com/posts/jay-kisan-das_pwcpromotion-professionalmilestone-growth-activity-7058024252133838848-gCO5",
      tag: "Promotion",
      title: "Promoted to Assistant Manager @PwC India",
      publishedDate: "May 01, 2023",
    },
  ],
  social: [
    { name: "Instagram", url: "https://www.instagram.com/the_avtar_jay/" },
    { name: "LinkedIn", url: "https://www.linkedin.com/in/jay-kisan-das/" },
    { name: "Twitter", url: "https://twitter.com/JayRomeojay67" },
    {
      name: "YouTube",
      url: "https://www.youtube.com/channel/UCg0OQbqjS85fEZ4jiXeQVAA",
    },
  ],
  contacts: [
    { type: "Email", value: "jaykisandas@gmail.com", linkType: "email" },
    { type: "Phone", value: "+91 9556539279", linkType: "phone" },
  ],
  companies: [
    { name: "Hashedin by Deloitte", url: "https://hashedin.com/", logoUrl: "" },
    { name: "PwC India", url: "https://www.pwc.in/", logoUrl: "" },
    { name: "tyfone", url: "https://tyfone.com/", logoUrl: "" },
    { name: "Livsoft", url: "https://livsoft.in/", logoUrl: "" },
    { name: "Goalsr", url: "https://www.goalsr.com/", logoUrl: "" },
  ],
};
